/**
 * Base HTTP Exception class
 * Similar to NestJS HttpException
 */
export class HttpException extends Error {
    public readonly statusCode: number;
    public readonly message: string;
    public readonly errorBody?: unknown; // JSON body from error response
    public readonly cause?: Error;

    constructor(statusCode: number, message: string, errorBody?: unknown, cause?: Error) {
        super(message);
        this.name = this.constructor.name;
        this.statusCode = statusCode;
        this.message = message;
        this.errorBody = errorBody;
        this.cause = cause;

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}
